// Synlig autopilot SEO moved from a shared Supabase project to Ascendly's
// own Convex backend (see convex/synligAutopilot/ in kunde-reaktivering-saas).
// This talks to Convex's plain HTTP query API directly with fetch rather than
// pulling in the `convex` npm package — the wire format is tiny and stable,
// and it avoids adding a client/dependency to a site that otherwise has none.
const CONVEX_URL = "https://bold-pony-700.eu-west-1.convex.cloud";
const TENANT_ID = "nx76yx104mty05rp6g9me8czas8cm9fx"; // Drammen Car Wash

async function convexQuery<T>(path: string, args: Record<string, unknown>): Promise<T> {
  const res = await fetch(`${CONVEX_URL}/api/query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ path, format: "convex_encoded_json", args: [args] }),
  });
  const json = await res.json();
  if (json.status === "error") throw new Error(json.errorMessage);
  return json.value as T;
}

export type Article = {
  id: string;
  title: string;
  slug: string;
  draft_raw: string;
  meta_description: string | null;
  published_at: string | null;
};

type ListRow = { title: string; slug: string; metaDescription: string; publishedAt?: number };
type FullRow = ListRow & { body: string };

export async function listPublishedArticles(): Promise<Article[]> {
  const rows = await convexQuery<ListRow[]>("synligAutopilot/publish:listPublishedArticles", {
    tenantId: TENANT_ID,
  });
  return rows.map((r) => ({
    id: r.slug,
    title: r.title,
    slug: r.slug,
    draft_raw: "",
    meta_description: r.metaDescription,
    published_at: r.publishedAt ? new Date(r.publishedAt).toISOString() : null,
  }));
}

export async function getPublishedArticleBySlug(slug: string): Promise<Article | null> {
  const row = await convexQuery<FullRow | null>("synligAutopilot/publish:getPublishedArticle", {
    tenantId: TENANT_ID,
    slug,
  });
  if (!row) return null;
  return {
    id: row.slug,
    title: row.title,
    slug: row.slug,
    draft_raw: row.body,
    meta_description: row.metaDescription,
    published_at: row.publishedAt ? new Date(row.publishedAt).toISOString() : null,
  };
}
